import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IFailedSlipResult, ISucceededSlipResult } from '../../../../betplacement/models';
import { LinearBetslipTrackingLocation } from '../../../../tracking/models';

@Component({
    selector: 'bs-digital-linear-result-links',
    templateUrl: './linear-result-links.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearResultLinksComponent {
    @Input() succeededSlips: ISucceededSlipResult[] = [];
    @Input() failedSlips: IFailedSlipResult[] = [];
    @Input() inColumn: boolean;
    @Input() keepPlacedBetsInBetslip: boolean;

    readonly trackingInformation = LinearBetslipTrackingLocation;

    get showQuickLinks(): boolean {
        return !this.inColumn;
    }
}
